
import { StoreManagementCreateItemRequest } from "@/common/api";
import QReleaseSetting from "@/components/common/qReleaseSetting.vue";
import { STATUS_STORE } from "@/model/releaseSetting";
import { Component } from "vue-property-decorator";

@Component({
  name: "qReleaseSettingLive",
})
export default class QReleaseSettingLive extends QReleaseSetting {
  public statusList = STATUS_STORE as any;
  public localStatus: any = StoreManagementCreateItemRequest.openStatus.HOLD;
}
